import { render, staticRenderFns } from "./farchive.vue?vue&type=template&id=fc28adf6&scoped=true&"
import script from "./farchive.vue?vue&type=script&lang=js&"
export * from "./farchive.vue?vue&type=script&lang=js&"
import style0 from "./farchive.vue?vue&type=style&index=0&id=fc28adf6&prod&lang=scss&scoped=true&"
import style1 from "./farchive.vue?vue&type=style&index=1&id=fc28adf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc28adf6",
  null
  
)

export default component.exports